module.exports = __webpack_public_path__ + "static/img/banner.936f67ea.png";